import { SplitTest } from 'entities/splitTest';
import { Client, Options } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { Service } from '../services';
import { convertToServerSplitTest, convertToSplitTest, ServerSplitTest } from './entityConversion';

const options: Options<SplitTest, ServerSplitTest> = {
  mapFromResponse: (item: ServerSplitTest) => ({ id: item.id, entity: convertToSplitTest(item) }),
  mapToRequest: convertToServerSplitTest,
};
const client = new Client(options);

export const { Actions, Selectors, Sagas } = createService<SplitTest, Service.SplitTests>({
  service: Service.SplitTests,
  client,
  // eslint-disable-next-line
  endpointCreator: '/sites/${siteId}/campaign_split_tests',
  stateConverter: (state: State) => state.campaigns.splitTests,
  sagas: ['GET_COLLECTION', 'CREATE', 'DELETE', 'UPDATE', 'REDIRECT_AFTER_CREATE'],
  redirectAfterCreateUrl: (siteId: string, _: string) => `/sites/${siteId}/campaigns/split_tests`,
});
